import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject } from 'rxjs';

@Component({
	selector: 'modal',
	templateUrl: './modal.component.html',
	styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

	private modalRef: NgbModalRef;
	private onClosedSubject: Subject<boolean> = new Subject();
	private onClosed$: Observable<boolean> = this.onClosedSubject.asObservable();

	@Input()
	size: string = "lg";

	@ViewChild( "content", { static: true } )
	content: ElementRef;

	constructor( private modalService: NgbModal ) {
	}

	public open() {
		this.modalRef = this.modalService.open( this.content, {
			ariaLabelledBy: 'modal-basic-title',
			centered: true,
			size: this.size,
			beforeDismiss: () => {
				this.onClosedSubject.next( false );
				return true;
			}
		});
	}

	public close() {
		this.onClosedSubject.next( false );
		this.modalRef.close();
	}

	public onClosed(): Observable<boolean> {
		return this.onClosed$;
	}

}
